// Import modules
import Navigation from 'modules/_navigation'
import SlideToggle from 'modules/_slide-toggle'
import VideoModal from './modules/_video-modal'
import TagShowMore from './modules/_tag-show-more'
import ReactRenderer from 'app/react/_react-renderer'
import Signup from 'modules/react/signup/for-self/Signup'
import CoursePlusCompanySignup from 'modules/react/signup/course-plus/company/CoursePlusCompanySignup'
import Search from 'modules/react/search/Search'
import CourseWithoutDatesSignup from 'modules/react/signup/without-dates/CourseWithoutDatesSignup'
import OBUSignup from 'modules/react/signup/obu/OBUSignup'
import FVUSignup from 'modules/react/signup/fvu/FVUSignup'
import GSKSignup from 'modules/react/signup/gsk/GSKSignup'
import SingleClassOrGSKSignup from 'modules/react/signup/SingleClassOrGSK/SingleClassOrGSKSignup'
import ScrollOffset from 'modules/_scroll-offset'
import GlobalSearch from 'modules/react/global-search/GlobalSearch'

window.addEventListener('load', () => {
// Use modules
  Navigation()
  SlideToggle()
  VideoModal()
  TagShowMore()
  ScrollOffset()

  ReactRenderer.registerComponent('Course.Signup.ForSelf', Signup)
  ReactRenderer.registerComponent('Course.Signup.CoursePlus.Company', CoursePlusCompanySignup)
  ReactRenderer.registerComponent('Search', Search)
  ReactRenderer.registerComponent('Course.Signup.WithoutDates', CourseWithoutDatesSignup)
  ReactRenderer.registerComponent('Course.Signup.OBU', OBUSignup)
  ReactRenderer.registerComponent('Course.Signup.FVU', FVUSignup)
  ReactRenderer.registerComponent('Course.Signup.GSK', GSKSignup)
  ReactRenderer.registerComponent('Course.Signup.CoursePlusOrGSK', SingleClassOrGSKSignup)
  ReactRenderer.registerComponent('GlobalSearch', GlobalSearch)

  ReactRenderer.render()
})
